import Icon1 from "../images/franchise/icon-franchise1.png";
import Icon2 from "../images/franchise/icon-franchise2.png";
import Icon3 from "../images/franchise/icon-franchise3.png";
import Icon4 from "../images/franchise/icon-franchise4.png";

export const FranchiseContent = [
    {
        id: 1,
        photo: Icon1,
        text: "Intégrer un réseau animé"
    },
    {
        id: 2,
        photo: Icon2,
        text: "Accéder à un suivi étape par étape"
    },
    {
        id: 3,
        photo: Icon3,
        text: "Prendre part à l’évolution de l’entreprise"
    },
    {
        id: 4,
        photo: Icon4,
        text: "Participer à une experience humaine et enrichissante"
    }
]